import { Store } from "./store";

const store = new Store();

export default store;
